export class ProductForCreateOrderRequest {
    productId?:number;
    quantity?: number;
}